import React from "react"
import Meta from "../Meta"
import EncheresSpace from "../../../components/EncheresSpace"
import {metaEnchere} from "../../../components/EncheresSpace/meta"

// Wrapper 2026 pour la page d'enchères. Le composant lui-même est partagé
// par tous les thèmes : ici on ne fait que poser le Meta et la marge sous le
// header, comme pour l'espace compte.
export default function EncheresPage({context}) {
    // Titre, description et image de partage de LA vente affichée : réglés par
    // le responsable, lus au rendu serveur — c'est ce que voit le groupe
    // WhatsApp où l'on colle le lien.
    const meta = metaEnchere(context)
    return (
        <>
            <Meta context={context} title={meta.title} description={meta.description} image={meta.image}/>
            <div style={context.render !== "embed" ? {marginTop: 32, minHeight: "60vh"} : undefined}>
                <EncheresSpace context={context}/>
            </div>
        </>
    )
}
